import SchoolAvatar from './SchoolAvatar';

export default function SchoolDirectoryRow({
  record,
  name,
  meta,
  seed,
  active = false,
  className = '',
  onClick,
  children,
  photoPath,
}) {
  const classes = ['sap-directory-row', className, active ? 'active' : ''].filter(Boolean).join(' ');

  return (
    <button type="button" className={classes} onClick={onClick}>
      <SchoolAvatar record={record} name={name} seed={seed} photoPath={photoPath} />
      <div className="sap-directory-copy">
        <span className="sap-directory-name">{name}</span>
        {meta ? <span className="sap-directory-meta">{meta}</span> : null}
        {children}
      </div>
      <span className="sap-directory-arrow">→</span>
    </button>
  );
}
